import { createListenerMiddleware } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '@/store/store'
import { UserFilesPollingActions } from '@/user_files/polling/store/slice'
import { selectIncompleteUploadedFileIds } from './selectors'
import { UppyFileUploadActions } from './slice'

export const uppyFileUploadListenerMiddleware = createListenerMiddleware()
const startListener = uppyFileUploadListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()

startListener({
  actionCreator: UserFilesPollingActions.pollBatchReceived,
  effect: async (action, listenerApi) => {
    const drawerFileIds = new Set(selectIncompleteUploadedFileIds(listenerApi.getState()))
    if (drawerFileIds.size === 0) return

    const returnedIds = new Set(Object.keys(action.payload.files))

    for (const [fileId, fileData] of Object.entries(action.payload.files)) {
      if (!drawerFileIds.has(fileId)) continue

      listenerApi.dispatch(
        UppyFileUploadActions.backendDataReceived({
          serverFileId: fileId,
          record: fileData.record,
          reductoJob: fileData.reducto_job,
          assets: fileData.assets,
        })
      )
    }

    for (const requestedId of action.payload.requestedIds) {
      if (!drawerFileIds.has(requestedId) || returnedIds.has(requestedId)) continue

      listenerApi.dispatch(
        UppyFileUploadActions.backendDataMissing({
          serverFileId: requestedId,
          error: 'Backend did not return file data (file may be missing or not owned)',
        })
      )
    }
  },
})
